<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                    <van-col span="12">
                        <div class="banner-title">{{tag == 0 ? '运动记录' : '心电数据'}}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content-body">
            <div class="dynamics">
                <div class="d-item" v-for="item in dynamicList">
                    <div class="d-top">
                        <img class="d-avatar"
                             :src="item.userAvatar ? item.userAvatar : defaultImg">
                        <div class="d-info">
                            <div class="d-username">{{userNameRemark ? userNameRemark : item.userName}}</div>
                            <div class="d-time">{{item.createTime}}</div>
                        </div>
                    </div>
                    <div class="d-sport" v-if="item.sportId" @click="openDynamicDesc(item)">
                        <div class="d-sport-type">{{item.sportType}}</div>
                        <div class="d-sport-info">{{(item.distance / 100000).toFixed(2)}}<span class="d-unit">公里</span>
                            <img class="d-sport-time" src="@/assets/theme/light/share/01home/08time.png">
                            {{formatSeconds3(item.actTime)}}
                        </div>
                        <img class="d-sport-icon" :src="require(`@/assets/share/home/${item.sportType}.svg`)">
                    </div>
                    <div class="d-ecg" v-if="item.ecgId" @click="openDynamicDesc(item)">
                        <van-row>
                            <van-col span="14">
                                <div class="d-ecg-left">
                                    <div class="ecg-info">
                                        <div v-if="!item.isError" class="ecg-normal"></div>
                                        <div v-if="item.isError" class="ecg-error"></div>
                                        <div class="ecg-conclusion">{{item.conclusion}}</div>
                                    </div>
                                    <div class="ecg-from">由<span class="ecg-add">{{item.deviceName}}</span>采集</div>
                                </div>
                            </van-col>
                            <div class="ecg-chart" :id="item.ecgId"></div>
                        </van-row>
                    </div>
                    <div class="d-bottom">
                        <van-row>
                            <van-col span="12">
                                <div class="d-b-item d-b-item-left">
                                    <img v-if="item.isLike" class="d-b-icon"
                                         src="@/assets/theme/light/share/01home/09liked.svg"
                                         @click="like(item, 0)">
                                    <img v-if="!item.isLike" class="d-b-icon"
                                         src="@/assets/theme/light/share/01home/09like.svg"
                                         @click="like(item, 1)">
                                    <span class="like-num">{{item.likeNum}}</span>
                                </div>
                            </van-col>
                            <van-col span="12" @click="clickComment(item, '', 0, item.userId)">
                                <div class="d-b-item">
                                    <img class="d-b-icon" src="@/assets/theme/light/share/01home/10commit.svg">
                                    <span class="comment-num">{{item.commentList.length > 0 ? item.commentList.length : '评论'}}</span>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                    <div class="d-comment" v-if="item.commentList.length > 0">
                        <div class="d-comment-box">
                            <div class="d-comment-item"
                                 @click="clickComment(item, c, 1, c.userId)"
                                 v-for="(c, index) in item.commentList" v-show="index < 3 || item.isent">
                            <span @click="toFriendDesc(c.userId)">
                            <img class="comment-avatar" :src="c.userAvatar ? c.userAvatar : defaultImg">
                                <span class="comment-username">{{c.userNameRemark ? c.userNameRemark : c.userName}}</span></span>
                                <span v-if="c.type == 1">
                                <span>回复</span>
                                <span class="comment-username"
                                      @click="toFriendDesc(c.toUserId)">{{c.toUserNameRemark ? c.toUserNameRemark : c.toUserName}}：</span>
                            </span>
                                <span v-if="c.type == 0" class="comment-username">:</span>
                                {{c.content}}
                            </div>
                            <div class="all-btn" v-show="item.commentList.length > 3" @click="openHide(item)">
                                {{item.isent ?
                                '收起' : '查看所有评论'}}>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="load-more" @click="loadMore()" v-if="pageSize * pageNum > count && count > 0">点击加载更多</div>
                <van-popup v-model="showComment" position="bottom" style="background: var(--bg-color-2)">
                    <div class="apply-value">
                        <van-field v-model="commentInfo.content" :placeholder="commentInfo.type == 0 ? '评论':'回复'">
                            <template #button>
                                <van-button size="mini" type="primary" @click="sendComment">发送</van-button>
                            </template>
                        </van-field>
                    </div>
                </van-popup>
            </div>
        </div>
    </div>
</template>

<script>
    import gpsBaidu from "../../components/gpsBaidu";
    import {Dialog, Toast} from 'vant';
    import {SwitchTime, SwitchTimeToM, GetYear, formatSeconds3} from '@/utils/dateUtils';
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'allDynamics',
        components: {
            gpsBaidu
        },
        data() {
            return {
                theme: 'light',
                userNameRemark: localStorage.getItem('userNameRemark'),
                tag: localStorage.getItem('allTag'),
                allSharerId: localStorage.getItem('allSharerId'),
                loading: true,
                defaultImg: require('@/assets/share/home/noImg.png'),
                count: 0,
                pageSize: 10,
                pageNum: 0,
                dynamicList: [],
                isLoading: false,
                showComment: false,
                currentD: {}, // 当前动态
                commentInfo: {}, // 评论内容
                year: GetYear(0), // 年份
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme
            }
            this.getDynamicsList();
            this.bindScroll();
        },
        methods: {
            loadMore() {
                this.year -= 1;
                this.count = 0;
                this.pageNum = 0;
                this.getDynamicsList();
            },
            back() {
                this.$router.back();
            },
            openDynamicDesc(item) {
                WebJSBridge.call("openDynamicDesc", {
                    ecgId: item.ecgId,
                    sportId: item.sportId,
                    sportType: item.sportType,
                    userAvatar: item.userAvatar,
                    startSportTime: item.createTime
                }, function (res) {
                    console.log("recieve callback")
                    console.log(res)
                });
            },
            getDynamicsList() {
                this.pageNum++;
                this.isLoading = true;
                this.$api.share.getFriendsRecord({
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    type: this.tag == 0 ? 'sport' : 'ecg',
                    sharerId: this.allSharerId,
                    year: this.year
                }).then(res => {
                    this.count = res.info.count;
                    this.dynamicList.push(...res.info.items);
                    this.isLoading = false;
                    for (let i = 0; i < res.info.items.length; i++) {
                        if (res.info.items[i].ecgId && res.info.items[i].ecgFragment) {
                            this.$nextTick(function () {
                                this.drawEcg(res.info.items[i])
                            })
                        }
                    }
                })
            },
            // 滚动回调函数
            scrollHande() {
                // 节流
                if (this.isLoading) return
                // 获取内容高度
                var scrollH = document.documentElement.scrollHeight
                // 获取窗口高度
                var innerH = window.innerHeight
                // 获取滚出去的内容高度
                var top = document.body.scrollTop || document.documentElement.scrollTop
                // 当内容还剩余200的高度未滚出的时候发送请求
                if (scrollH - top - innerH < 200) {
                    // 发送请求
                    this.getDynamicsList();
                }
            },
            // 绑定scroll事件
            bindScroll() {
                window.addEventListener('scroll', this.scrollHande)
            },
            // 清除scroll事件
            clearScroll() {
                window.removeEventListener('scroll', this.scrollHande)
            },
            checkPower(sportType) {
                let tag = 0;
                if (sportType == '自由训练' || sportType == '俯卧撑' || sportType == '深蹲' || sportType == '卷腹' || sportType == '平板支撑' || sportType == '椭圆机' || sportType == '划船机' || sportType == '跳绳') {
                    tag = 1;
                }
                return tag;
            },
            dealTime(n) {
                return SwitchTime(n);
            },
            dealSwolf(item) {
                let is806 = 0;
                if (item.watchName) {
                    if (item.watchName.indexOf("TA806") != -1) {
                        is806 = 1;
                    }
                } else {
                    is806 = 1;
                }
                let swolf = item.avgSwolf;
                if (is806) {
                    swolf = parseInt(swolf / 10)
                }
                return swolf;
            },
            dealPach(item) {
                let is806 = 0;
                if (item.watchName) {
                    if (item.watchName.indexOf("TA806") != -1) {
                        is806 = 1;
                    }
                } else {
                    is806 = 1;
                }
                let value = item.avgSpeed;
                if (!is806 && (item.sportType != '室内游泳')) {
                    value = value == 0 ? 0 : 10000 / (value ? value : 1);
                }
                if (!is806 && (item.sportType == '室内游泳')) {
                    value = value == 0 ? 0 : 1000 / (value ? value : 1);
                }
                return SwitchTimeToM(value);
            },
            clickComment(item, c, type, toUserId) {
                this.currentD = item;
                this.commentInfo = {
                    ecgId: item.ecgId,
                    sportType: item.sportType,
                    sportId: item.sportId,
                    startSportTime: item.createTime,
                    type: type,
                    toUserId,
                    content: '',
                    userId: localStorage.getItem('userId'),
                    userAvatar: localStorage.getItem('userAvatar').indexOf('http') != -1 ? localStorage.getItem('userAvatar') : '',
                    userName: localStorage.getItem('userName'),
                    toUserName: c ? (c.userNameRemark ? c.userNameRemark : c.userName) : ''
                }
                this.showComment = true;
            },
            sendComment() {
                this.$api.share.comment(this.commentInfo).then(res => {
                    this.currentD.commentList.push(this.commentInfo);
                    this.$set(this.currentD, 'commentList', this.currentD.commentList);
                    this.showComment = false;
                    this.commentInfo = {}
                }).catch(e => {
                    Toast({message: '发言不符合社区规范！'});
                })
            },
            drawEcg(item) {
                let a = item.ecgFragment;
                let b = a.split(',');
                let c = [];
                for (let i = 0; i < b.length; i++) {
                    c.push(i);
                }
                let myChart = this.$echarts.init(document.getElementById(item.ecgId));
                myChart.setOption({
                    grid: {
                        top: 0,
                        bottom: 0,
                        left: 10,
                        right: 10
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        data: c
                    },
                    yAxis: {
                        type: 'value',
                        position: 'right',
                        axisLabel: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        }
                    },
                    series: [
                        {
                            data: b,
                            type: 'line',
                            symbol: 'none',
                            color: '#FF0101',
                            smooth: false,
                            lineStyle: {
                                width: 3
                            }
                        }
                    ]
                }, true);
            },
            like(item, isLike) {
                this.$api.share.like({
                    ecgId: item.ecgId,
                    sportId: item.sportId,
                    sportType: item.sportType,
                    startSportTime: item.createTime,
                    isLike,
                    toUserId: item.userId
                }).then(res => {
                    this.$set(item, 'isLike', isLike);
                    if (isLike) {
                        this.$set(item, 'likeNum', item.likeNum + 1);
                    } else {
                        this.$set(item, 'likeNum', item.likeNum - 1);
                    }
                })
            },
            openHide(item) {
                this.$set(item, 'isent', !item.isent)
            },
            formatSeconds3(m) {
                return formatSeconds3(m)
            }
        },
        // 页面销毁之前，清除scroll
        destroyed() {
            this.clearScroll();
        }
    }
</script>

<style scoped>
    .dynamics {
        margin: 15px 15px;
    }

    .d-item {
        width: 100%;
        background: var(--bg-color-2);
        margin-bottom: 10px;
        border-radius: 6px;
        padding-bottom: 6px;
    }

    .d-avatar {
        border-radius: 50%;
        width: 40px;
        height: 40px;
        border: 2px solid var(--text-color-1);
        margin: 14px 10px 15px 17px;
        vertical-align: top;
    }

    .d-info {
        display: inline-block;
        margin-top: 14px;
    }

    .d-username {
        opacity: 0.9;
        font-size: 14px;
        line-height: 24px;
        color: var(--text-color-1);
    }

    .d-time {
        opacity: 0.4;
        font-size: 12px;
        color: var(--text-color-1);
    }

    .icon-box {
        width: 56px;
        height: 56px;
        border-radius: 4px;
        background: var(--text-color-1);
        border: 1px solid #343434;
        margin: 12px 10px 10px 15px;
        display: inline-block;
        vertical-align: top;
    }

    .s-info {
        display: inline-block;
    }

    .s-num-box {
        margin-top: 3px;
    }

    .s-num-unit {
        opacity: 0.7;
        font-size: 11px;
    }

    .s-num {
        font-family: BlackItalic;
        font-size: 35px;
        opacity: 1;
        letter-spacing: 3px;
        margin-right: 2px;
    }

    .s-sub-icon {
        width: 11px;
        vertical-align: top;
    }

    .s-sub {
        opacity: 0.6;
        margin-top: 5px;
        font-size: 11px;
    }

    .s-type {
        float: right;
        background-size: contain;
        width: 72px;
        height: 72px;
        margin-right: 5px;
    }

    .s-type-text {
        text-align: center;
        opacity: 0.6;
        margin-top: 30px;
        font-size: 14px;
        font-weight: 400;
    }

    .d-sport {
        width: 315px;
        height: 65px;
        background: var(--bg-color-1);
        margin: 0 auto;
        border-radius: 13px 13px 13px 13px;
        position: relative;
    }

    .d-sport-type {
        font-size: 15px;
        color: var(--text-color-1);
        position: absolute;
        top: 10px;
        left: 16px;

    }

    .d-desc-item {
        text-align: center;
        margin-bottom: 16px;
    }

    .d-desc-center {
        /*border-left: 1px solid var(--bg-color-2);*/
        position: relative;
    }

    .d-desc-center:before {
        content: '';
        position: absolute;
        left: 0;
        top: 35%;
        bottom: auto;
        right: auto;
        height: 40%;
        width: 1px;
        background-color: #636363;
    }

    .d-desc-center:after {
        content: '';
        position: absolute;
        left: auto;
        top: 35%;
        bottom: auto;
        right: 0;
        height: 40%;
        width: 1px;
        background-color: #636363;
    }

    .desc-num {
        font-family: Bold;
        font-size: 24px;
    }

    .desc-title {
        color: #A5A5A5;
        font-size: 11px;
    }

    .d-bottom {
        /*border-top: 1px solid var(--text-color-1);*/
    }

    .d-b-item {
        text-align: center;
        font-size: 13px;
        line-height: 22px;
        margin-top: 6px;
        color: var(--text-color-1);
    }

    .d-b-icon {
        width: 22px;
        vertical-align: bottom;
    }

    .d-b-item-left {
        position: relative;
    }

    /*.d-b-item-left:after {*/
    /*    content: '';*/
    /*    position: absolute;*/
    /*    left: auto;*/
    /*    top: 13%;*/
    /*    bottom: auto;*/
    /*    right: 0;*/
    /*    height: 70%;*/
    /*    width: 1px;*/
    /*    background-color: var(--text-color-1);*/
    /*}*/

    .ecg-info {
        position: relative;
    }

    .ecg-normal {
        width: 6px;
        height: 6px;
        background: #00BD9B;
        border-radius: 50%;
        opacity: 1;
        position: absolute;
        top: 50%;
        left: 15px;
    }

    .ecg-error {
        width: 6px;
        height: 6px;
        background: #FF0101;
        border-radius: 50%;
        opacity: 1;
        position: absolute;
        top: 50%;
        left: 15px;
    }

    .ecg-conclusion {
        display: inline-block;
        font-size: 15px;
        color: var(--text-color-1);
        margin-left: 25px;
        margin-top: 10px;
    }

    .ecg-from {
        color: #A5A5A5;
        font-size: 12px;
        margin-left: 15px;
        margin-top: 5px;
    }

    .ecg-add {
        font-weight: bold;
        color: var(--text-color-1) !important;
        margin: 0 2px;
    }

    .d-ecg-left {
        margin: 5px 0 15px 0;
    }

    .d-ecg {
        width: 315px;
        position: relative;
        background: var(--bg-color-1);
        border-radius: 10px 10px 10px 10px;
        margin: 0 auto;
    }

    .ecg-chart {
        position: absolute;
        right: 0;
        top: 0px;
        width: 150px;
        height: 73px;
    }

    .d-comment {
        border-radius: 10px 10px 10px 10px;
        border: 2px solid var(--text-color-1);
        margin: 6px 10px 6px 10px;
    }

    .d-comment-box {
        padding: 6px 12px;
    }

    .d-comment-item {
        color: var(--text-color-2);
        line-height: 26px;
        font-size: 14px;
    }

    .comment-avatar {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        vertical-align: middle;
    }

    .comment-comment {
        color: #999999;
    }

    .comment-username {
        color: var(--text-color-1);
    }

    .all-btn {
        color: #00BD9B;
        font-size: 12px;
        margin-left: 20px;
    }


    /deep/ input {
        background-color: var(--bg-color-1);
        color: var(--text-color-1);
        font-size: 14px;
        caret-color: #20D38F;
        padding: 7px 10px;
        height: 28px;
        border-radius: 6px;
    }

    /deep/ input::-webkit-input-placeholder {
        color: var(--text-color-1);
        opacity: 0.2;
    }

    /deep/ input::-moz-placeholder {
        color: var(--bg-color-2);
        opacity: 0.6;
    }

    /deep/ input:-moz-placeholder {
        color: var(--bg-color-2);
        opacity: 0.6;
    }

    /deep/ input::-ms-input-placeholder {
        color: var(--bg-color-2);
        opacity: 0.6;
    }

    /deep/ .van-cell {
        background-color: var(--bg-color-2) !important;
        border-radius: 6px;
        padding: 8px;
    }

    /deep/ .van-button--primary {
        background-color: #00BD9B;
        border-radius: 6px;
        font-size: 14px;
        padding: 7px;
        height: 28px;
        border-color: #00BD9B;
    }

    .load-more {
        text-align: center;
        font-size: 14px;
        margin: 0 auto 10px;
    }

    .content-body {
        color: var(--text-color-1);
    }

    .d-sport-info {
        font-family: PP;
        font-size: 19px;
        position: relative;
        top: 30px;
        left: 16px;
        display: flex;
        align-items: center;
    }

    .d-unit {
        font-size: 13px;
        color: var(--text-color-2);
        margin-left: 4px;
        vertical-align: middle;
    }

    .d-sport-time {
        width: 17px;
        margin-left: 12px;
        margin-right: 4px;
        vertical-align: middle;
    }

    .d-sport-icon {
        width: 30px;
        position: absolute;
        right: 21px;
        top: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/views/shareLight/17allDynamics.vue